import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { WarehouseRestockStatus } from '../enums/warehouse-restock-status';

@Injectable({
  providedIn: 'root',
})
export class WarehouseRestockStatusProviderService {
  private entries = new Map<WarehouseRestockStatus, string>([
    [WarehouseRestockStatus.Approved, 'Zatwierdzony'],
    [WarehouseRestockStatus.Draft, 'Szkic'],
    [WarehouseRestockStatus.Rejected, 'Odrzucony'],
  ]);

  public label(status: WarehouseRestockStatus): Observable<string> {
    const entry = this.entries.get(status);

    if (isNil(entry)) {
      throw new EntryNotFoundException(`The entry for "${status}" not found.`);
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<WarehouseRestockStatus>[]> {
    const result = Array.from(this.entries.entries()).map(
      ([status, label]) => new SelectItem(label, status),
    );

    return of(result);
  }
}
